import dayjs from 'dayjs';

import 'dayjs/locale/ko';

import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.locale('ko');
dayjs.extend(quarterOfYear);
dayjs.extend(relativeTime);

dayjs.extend(utc);
dayjs.extend(timezone);
